<template>
  <TabbedPortletContainer>
    <TabbedPortlet>

      <TabbedPortletHead>
        <template slot="buttons">
          <button class="btn btn-danger btn-wide" v-if="false">New</button>
        </template>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{ 'active': meta.type === 'quote' }"
            :to="{ name: 'quotes' }">
            <font-awesome-icon :icon="['fas', 'folder-open']" size="lg" />
            <span class="text-capitalize">Quotes</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{ 'active': meta.type === 'draft' }"
            :to="{ name: 'drafts' }">
            <font-awesome-icon :icon="['fas', 'folder-open']" size="lg" />
            <span class="text-capitalize">Drafts</span>
          </router-link>
        </li>
      </TabbedPortletHead>

      <TabbedPortletBody>
        <div class="tab-content">
          <TabbedPortletBodyTab :show="true">
            <OpportunityListSearch
              ref="oplSearch"
              :isSearching="isSearching"
              @onSearch="onSearch"
              @onResetSearch="onResetSearch" />
            <OpportunityListTable
              v-if="opportunitiesSaved"
              :data="opportunitiesSaved"
              :meta="meta"
              :isSearching="isSearching"
              :searchParams="params"
              @onDeleteOportunity="onDeleteOportunity" />
            <OpportunityListPagination
              v-if="Array.isArray(opportunitiesSaved) && opportunitiesSaved.length"
              ref="oplPagination"
              :total="total"
              :perPage="perPage"
              :currentPage="page"
              :maxPages="10"
              @onPage="onPage" />
          </TabbedPortletBodyTab>
        </div>
      </TabbedPortletBody>

    </TabbedPortlet>
  </TabbedPortletContainer>
</template>

<script>
import { mapGetters } from 'vuex'

import TabbedPortletContainer from '@/components/_shared/tabbed-portlet/TabbedPortletContainer.vue'
import TabbedPortlet from '@/components/_shared/tabbed-portlet/TabbedPortlet.vue'
import TabbedPortletHead from '@/components/_shared/tabbed-portlet/TabbedPortletHead.vue'
import TabbedPortletBody from '@/components/_shared/tabbed-portlet/TabbedPortletBody.vue'
import TabbedPortletBodyTab from '@/components/_shared/tabbed-portlet/TabbedPortletBodyTab.vue'

import OpportunityListSearch from '@/components/opportunity-list/OpportunityListSearch.vue'
import OpportunityListTable from '@/components/opportunity-list/OpportunityListTable.vue'
import OpportunityListPagination from '@/components/opportunity-list/OpportunityListPagination.vue'

import config from '@/config'

export default {
  name: 'OpportunityListWrapper',
  data () {
    return {
      isSearching: false,
      page: 0,
      params: {
        query: '',
        type: this.meta.typeId,
        limit: config.opportunityList.pagination.byPage,
        offset: 0
      }
    }
  },
  props: {
    meta: {
      type: Object,
      required: true
    }
  },
  components: {
    TabbedPortletContainer,
    TabbedPortlet,
    TabbedPortletHead,
    TabbedPortletBody,
    TabbedPortletBodyTab,
    OpportunityListSearch,
    OpportunityListTable,
    OpportunityListPagination
  },
  computed: {
    ...mapGetters({
      'opportunities': 'opportunity/opportunitiesSaved'
    }),
    opportunitiesSaved () {
      if (this.opportunities && this.opportunities.items) {
        return this.opportunities.items
      }
      return []
    },
    total () {
      if (this.opportunities && Number(this.opportunities.total) > 0) {
        return this.opportunities.total
      }
      return 0
    },
    perPage () {
      return config.opportunityList.pagination.byPage
    },
    currentPage () {
      return this.page
    }
  },
  methods: {
    onDeleteOportunity () {
      this.page = 0
    },
    onSearch (params) {
      this.page = 0
      params.offset = 0
      this._search(params)
    },
    onResetSearch (params) {
      this.page = 0
      params.offset = 0
      this._search(params)
    },
    onPage (page) {
      this.page = page
      this.params.offset = Number(this.params.limit) * Number(page)
      this._search(this.params)
    },
    _search (params) {
      this.isSearching = true
      const payload = {
        query: params.query,
        type: this.meta.typeId,
        limit: params.limit,
        offset: params.offset
      }
      this.params = payload
      this.$store
        .dispatch('opportunity/listOpportunities', payload)
        .then(response => {
          this.isSearching = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-link:hover,
.nav-link.active,
a.nav-link:hover,
a.nav-link.active {
  color: #cc0000 !important;
  border-bottom: 1px solid #cc0000 !important;
}
</style>
